import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AccordionComponent } from '../components/accordion/accordion.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from './footer/footer.component';
import { DynamicHtmlComponent } from './dynamic-html/dynamic-html.component';
import { HeadingComponent } from './dynamic-html/nodes/heading/heading.component';
import { ParagraphComponent } from './dynamic-html/nodes/paragraph/paragraph.component';
import { ListComponent } from './dynamic-html/nodes/list/list.component';
import { DelimiterComponent } from './dynamic-html/nodes/delimiter/delimiter.component';
import { QuoteComponent } from './dynamic-html/nodes/quote/quote.component';
import { ButtonComponent } from './dynamic-html/nodes/button/button.component';
import { MultiImageComponent } from './dynamic-html/nodes/multiimage/multiimage.component';
import { TableComponent } from './dynamic-html/nodes/table/table.component';
import { FAQSComponent } from './dynamic-html/nodes/faqs/faqs.component';
import { ContactListComponent } from './dynamic-html/nodes/contact-list/contact-list.component';
import { ParticipatingStoresComponent } from './dynamic-html/nodes/participating-stores/participating-stores.component';
import { ContactStripComponent } from './contact-strip/contact-strip.component';
import { RelatedContentComponent } from './related-content/related-content.component';
import { SocialShareComponent } from './social-share/social-share.component';
import { ShareModule } from 'ngx-sharebuttons';
import { CTAComponent } from './dynamic-html/nodes/cta/cta.component';
import { ProductGridComponent } from './dynamic-html/nodes/product-grid/product-grid.component';
import { PopoverListComponent } from './popover-list/popover-list.component';
import { FeatureComponent } from './feature/feature.component';
import { CardComponent } from './card/card.component';
import { ScriptHackComponent } from './scripthack/scripthack.component';
import { TwitterComponent } from './dynamic-html/nodes/twitter/twitter.component';
import { FacebookComponent } from './dynamic-html/nodes/facebook/facebook.component';
import { InstagramComponent } from './dynamic-html/nodes/instagram/instagram.component';
import { YouTubeComponent } from './dynamic-html/nodes/youtube/youtube.component';
import { SafePipe } from '../pipes/safe.pipe';
import { FormComponent } from './dynamic-html/nodes/form/form.component';
import { SelectListComponent } from './select-list/select-list.component';
import { PopoverSocialShareComponent } from './popover-social-share/popover-social-share.component';
import { NavigationDropdownComponent } from './navigation-dropdown/navigation-dropdown.component';
import { ImageComponent } from './dynamic-html/nodes/image/image.component';
import { ImgFormatComponent } from './img-format/img-format.component';
import { ServicesIconComponent } from './services-icon/services-icon.component';
import { MovieCardComponent } from './movie-card/movie-card.component';
import { ExploreComponent } from './dynamic-html/nodes/explore/explore.component';
import { HeroComponent } from './dynamic-html/nodes/hero/hero.component';
import { LoginComponent } from './auth/login/login.component';
import { FavoriteItemComponent } from './favorite-item/favorite-item.component';
import { SearchComponent } from './search/search.component';
import { TypeaheadComponent } from './typeahead/typeahead.component';
import { YoutubePipe } from '../pipes/youtube.pipe';
import { MappedinComponent } from './mappedin/mappedin.component';
import { HrefToRouterLinkDirective } from '../directives/href-routerlink';
import { SponsorStripComponent } from './sponsor-strip/sponsor-strip.component';
import { SponsorOverlayComponent } from './sponsor-overlay/sponsor-overlay.component';
import { ImageCardComponent } from './dynamic-html/nodes/image-card/image-card.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { OrDividerComponent } from './or-divider/or-divider.component';
import { HeaderComponent } from './header/header.component';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ShareModule,
    GoogleSigninButtonModule,
  ],
  exports: [
    YoutubePipe,
    FormsModule,
    ReactiveFormsModule,
    FooterComponent,
    AccordionComponent,
    ContactStripComponent,
    NavigationDropdownComponent,
    PopoverListComponent,
    SelectListComponent,
    SocialShareComponent,
    PopoverSocialShareComponent,
    RelatedContentComponent,
    CardComponent,
    FeatureComponent,
    ScriptHackComponent,
    DynamicHtmlComponent,
    HeadingComponent,
    ParagraphComponent,
    ListComponent,
    DelimiterComponent,
    QuoteComponent,
    ButtonComponent,
    ImageComponent,
    MultiImageComponent,
    TableComponent,
    FAQSComponent,
    ContactListComponent,
    ParticipatingStoresComponent,
    CTAComponent,
    ProductGridComponent,
    TwitterComponent,
    FacebookComponent,
    InstagramComponent,
    YouTubeComponent,
    SafePipe,
    SelectListComponent,
    PopoverSocialShareComponent,
    NavigationDropdownComponent,
    ImgFormatComponent,
    ServicesIconComponent,
    MovieCardComponent,
    ExploreComponent,
    HeroComponent,
    LoginComponent,
    FavoriteItemComponent,
    SearchComponent,
    TypeaheadComponent,
    FormComponent,
    MappedinComponent,
    HrefToRouterLinkDirective,
    SponsorStripComponent,
    SponsorOverlayComponent,
    ImageCardComponent,
    OrDividerComponent,
    HeaderComponent,
  ],
  declarations: [
    YoutubePipe,
    FooterComponent,
    AccordionComponent,
    ContactStripComponent,
    NavigationDropdownComponent,
    PopoverListComponent,
    SelectListComponent,
    SocialShareComponent,
    PopoverSocialShareComponent,
    RelatedContentComponent,
    CardComponent,
    FeatureComponent,
    ScriptHackComponent,
    DynamicHtmlComponent,
    SponsorStripComponent,
    HeadingComponent,
    ParagraphComponent,
    ListComponent,
    DelimiterComponent,
    QuoteComponent,
    ButtonComponent,
    ImageComponent,
    MultiImageComponent,
    TableComponent,
    FAQSComponent,
    ContactListComponent,
    ParticipatingStoresComponent,
    CTAComponent,
    ProductGridComponent,
    TwitterComponent,
    FacebookComponent,
    InstagramComponent,
    YouTubeComponent,
    SafePipe,
    SelectListComponent,
    PopoverSocialShareComponent,
    NavigationDropdownComponent,
    ImgFormatComponent,
    ServicesIconComponent,
    MovieCardComponent,
    ExploreComponent,
    HeroComponent,
    LoginComponent,
    FavoriteItemComponent,
    SearchComponent,
    TypeaheadComponent,
    FormComponent,
    MappedinComponent,
    HrefToRouterLinkDirective,
    SponsorStripComponent,
    SponsorOverlayComponent,
    ImageCardComponent,
    OrDividerComponent,
    HeaderComponent,
  ],
})
export class ComponentsModule { }